import { ToggleItem } from '@/components/ToggleItem';
import type { FC } from 'react';
import { useNotification } from '../../hooks';
import { UnsubscribeConfirmDialog } from '../UnsubscribeConfirmDialog';

interface NotificationItemProps {
  dataKey: string;
  title: string;
  subText: string;
  toggled: boolean;
  popupMainText: string;
  popupSubText: string;
  popupConfirmText: string;
}

export const NotificationItem: FC<NotificationItemProps> = ({
  dataKey,
  title,
  subText,
  toggled,
  popupMainText,
  popupSubText,
  popupConfirmText,
}) => {
  const { showDialog, setShowDialog, isToggling, handleToggleNotification } = useNotification();

  const handleToggle = () => {
    if (toggled) {
      // Show dialog to confirm unsubscribe
      setShowDialog(true);
    } else {
      handleToggleNotification({
        [dataKey]: true,
      });
    }
  };

  return (
    <ToggleItem
      title={title}
      subText={subText}
      toggled={toggled}
      isToggling={isToggling}
      onToggle={handleToggle}
      popup={
        <UnsubscribeConfirmDialog
          showDialog={showDialog}
          setShowDialog={setShowDialog}
          onUnsubscribe={async () =>
            handleToggleNotification({
              [dataKey]: false,
            })
          }
          mainText={popupMainText}
          subText={popupSubText}
          confirmText={popupConfirmText}
        />
      }
    />
  );
};
